import {
  Card,
  Skeleton,
  Row,
  Col,
  Tag,
  Descriptions,
  Timeline,
  Divider,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getOrderDetailsById } from "../../../../api/order";
import Back from "../../../../assets/icons/LeftBack.svg";
import colors from "../../../../share/constants/constants";
import ServiceCard from "../allOrders/serviceCard";

const OrderDetails = () => {
  let { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [timeline, setTimeline] = useState(null);

  const OrderStatusTag = (status) => {
    return (
      <>
        {status === "COMPLETED" ? (
          <Tag color="success">Completed</Tag>
        ) : (
          <Tag color="warning">Not Redeemed</Tag>
        )}
      </>
    );
  };

  const orderKeys = [
    {
      label: "Order#",
      value: orderDetails?.orderNumber,
      children: orderDetails?.orderNumber,
    },
    {
      label: "Vendor",
      value: orderDetails?.businessId?.businessName,
      children: orderDetails?.businessId?.businessName,
    },
    {
      label: "Customer",
      value: `${orderDetails?.userId?.firstName} ${orderDetails?.userId?.lastName}`,
      children: `${orderDetails?.userId?.firstName} ${orderDetails?.userId?.lastName}`,
    },
    {
      label: "Customer Phone",
      value: orderDetails?.userId?.phoneNumber,
      children: orderDetails?.userId?.phoneNumber,
    },
    {
      label: "Amount ($)",
      value: `$${orderDetails?.price}`,
      children: (() => {
        const bannerText = orderDetails?.items?.find((item) => item?.cartDiscountRuleBannerText)?.cartDiscountRuleBannerText;
        return (
          <div className="flex flex-col gap-0.5">
            <span>${orderDetails?.price}</span>
            {bannerText && <Tag color="green">{bannerText}</Tag>}
          </div>
        );
      })(),
    },
    {
      label: "Earned Points",
      value: orderDetails?.earnedPoints || 0,
      children: orderDetails?.earnedPoints || 0,
    },
    {
      label: "Discount",
      value: orderDetails?.discount || 0,
      children: orderDetails?.discount || 0,
    },
    {
      label: "Customer Email",
      value: orderDetails?.userId?.email,
      children: orderDetails?.userId?.email,
    },
    {
      label: "Status",
      value: orderDetails?.orderStatus,
      children: OrderStatusTag(orderDetails?.orderStatus),
    },

    {
      label: "Created At",
      value: orderDetails?.createdAt,
      children: moment(orderDetails?.createdAt).format("MM/DD/YYYY hh:mm A"),
    },
  ];

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const res = await getOrderDetailsById(id);
        setOrderDetails(res);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    let services = [];

    const timeline = [];
    if (orderDetails) {
      timeline.push({
        color: "blue",
        children: `${orderDetails?.userId?.firstName} ${
          orderDetails?.userId?.lastName
        } placed the order at ${moment(orderDetails?.createdAt).format(
          "MM/DD/YYYY hh:mm A"
        )}`,
      });

      if (orderDetails?.orderStatus === "COMPLETED") {
        timeline.push(
          {
            color: "blue",
            children: <>Order status is {OrderStatusTag("NOT_REDEEMED")}</>,
          },
          {
            color: "green",
            children: (
              <>
                Order completed with status{" "}
                {OrderStatusTag(orderDetails?.orderStatus)} at{" "}
                {moment(orderDetails?.updatedAt).format("MM/DD/YYYY hh:mm A")}
              </>
            ),
          }
        );
      } else {
        timeline.push({
          color: "blue",
          children: (
            <>Order status is {OrderStatusTag(orderDetails?.orderStatus)}</>
          ),
        });
      }
    }
    setTimeline(timeline);
  }, [orderDetails]);

  return (
    <div>
      <div className="grid gap-2 space-x-2 w-full pr-2">
        <div className="flex pt-3 pl-3 place-content-between">
          <Link to="/main/orders">
            <div className="flex items-center">
              <div className="w-4.4 m-auto grid justify-center h-auto py-1 rounded-lg bg-primaryPurple cursor-pointer">
                <img src={Back} alt="Edit Icon" className="" />
              </div>
              <span className="text-lg font-bold text-black ml-1">Orders</span>
            </div>
          </Link>
        </div>

        <div>
          <Card className="rounded-2xl bg-white xl:relative">
            {loading &&
              !orderDetails &&
              [1, 1, 1].map((m, i) => (
                <div
                  className="flex flex-row"
                  key={i}
                  data-testid="loading-skeleton"
                >
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                </div>
              ))}

            {!loading && orderDetails && (
              <Descriptions
                layout="vertical"
                bordered
                column={{ xs: 2, sm: 2, md: 4 }}
                items={orderKeys}
                labelStyle={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: colors.primaryPurple,
                }}
              />
            )}
          </Card>
          <br />
          <Card className="px-2 py-1 rounded-2xl bg-gray xl:relative">
            <div>
              <div>
                <p className="text-lg font-bold text-black">
                  Services Included in Order No. {orderDetails?.orderNumber}
                </p>

                {orderDetails?.items &&
                  orderDetails?.items.map((item) => {
                    return (
                      <ServiceCard
                        services={item}
                        business={item?.serviceDetails?.businessId}
                        showExtra={false}
                      />
                    );
                  })}
              </div>
              <Divider orientation="left">Order Timeline</Divider>
              <Timeline items={timeline} />
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
